<template>

  <tr>
    <td class="text-truncate">
      <div class="photo">
        <Avatar
          :src="imgSrc"
          :name="value.user_id.name"
          size="30px"
          radius="15px"
          resize="100x100x1" />
      </div>
    </td>
    <td class="text-truncate">
      <a
        href="javascript:void(0)"
        @click="showEditModal(value)"
        v-if="value._id!==profile._id">{{ value.user_id.name }}</a>
      <span
        v-if="value._id===profile._id">{{ value.user_id.name }}</span>
      <MemberUserForm
        v-if="modal_select"
        :initMember="modal_select" 
        @hideModal="hideModal()" 
        @deleted="deleted();" 
        @saved="saved();" />
    </td>
    <td class="text-truncate">{{ value.user_id.email }}</td>
    <td class="text-truncate"><span class="font-weight-bold" :class="{'text-success': value.active}">{{ value.active?'Ativo':'Inativo' }}</span></td>
    <td class="text-truncate">{{ value.created_at ? $d(new Date(value.created_at), 'short') : null }}</td>
    <td class="text-truncate"><span v-if="value.role_id">{{ value.role_id.name }}</span></td>
  </tr>

</template>

<script>
import config from '@/config'
import MemberUserForm from './MemberUserForm'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'Member',
  components: {
    MemberUserForm,
    Avatar
  },
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      loading: true,
      modal_select: false
    }
  },
  computed: {
    profile () {
      return this.$store.getters.getProfile
    },
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.value.user_id.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    }
  },
  created () {
  },
  methods: {
    showEditModal (value) {
      this.modal_select = value
    },
    hideModal () {
      this.modal_select = false
    },
    deleted () {
      this.$emit('deleted')
      this.hideModal()
    },
    saved (value) {
      this.$emit('saved', value)
      this.hideModal()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.photo {
  margin: -5px 0; 
}
</style>



// WEBPACK FOOTER //
// src/components/Member/MemberUserItem.vue